export default {
  审计管理列表: "審計管理列表",
  拜访管理列表: "拜訪管理列表",
  添加: "添加",
  导入: "導入",
  供应商: "供應商",
  物料: "物料",
  "请输入供应商编号/名称": "請輸入供應商編號/名稱",
  "请输入物料编号/名称": "請輸入物料編號/名稱",
  拜访类型: "拜訪類型",
  请选择拜访类型: "請選擇拜訪類型",
  物料类别: "物料類別",
  请选择物料类别: "請選擇物料類別",
  负责人: "負責人",
  请选择负责人: "請選擇負責人",
  工厂: "工廠",
  请选择工厂: "請選擇工廠",
  审计方式: "審計方式",
  请选择审计方式: "請選擇審計方式",
  拜访状态: "拜訪狀態",
  供应商阶段: "供應商階段",
  供应商编号: "供應商編號",
  供应商名称: "供應商名稱",
  二级物料类别: "二級物料類別",
  供货物料: "供應物料",
  上一年度采购金额: "上一年度採購金額",
  "上一年度采购金额（HKD）": "上一年度採購金額（HKD）",
  拜访日期: "拜訪日期",
  操作: "操作",
  审计状态: "審計狀態",
  审计需求工厂: "審計需求工廠",
  审计日期: "審計日期",
  待通知供应商: "待通知供應商",
  待拜访: "待拜訪",
  拜访中: "拜訪中",
  待提交拜访结果: "待提交拜訪結果",
  已结束: "已結束",
  待供应商提供文件: "待供應商提供文件",
  待审计: "待審計",
  审计中: "審計中",
  待提交审计结果: "待提交審計結果",
  巩固战略伙伴关系: "鞏固戰略夥伴關係",
  解决特定业务问题: "解決特定業務問題",
  现场评估与审核: "現場評估與審核",
  日常沟通: "日常溝通",
  现场审计: "現場審計",
  纸质审计: "紙質審計",
  远程审计: "遠程審計",
  第三方審計: "第三方審計",
  查看: "查看",
  編輯: "編輯",
  删除: "刪除",
  通知供应商: "通知供應商",
  填写拜访结果: "填寫拜訪結果",
  填写审计结果: "填寫審計結果",
  供应商拜访登记表: "供應商拜訪登記表",
  添加审计记录: "添加審計記錄",
  編輯拜訪記錄: "編輯拜訪記錄",
  編輯審計記錄: "編輯審計記錄",
  查看拜访记录: "查看拜訪記錄",
  查看审计记录: "查看審計記錄",
  导入审计记录: "導入審計記錄",
  供应商信息: "供應商資訊",
  国家: "國家",
  "省份/城市": "省份/城市",
  "街道/门牌号": "街道/門牌號",
  物料信息: "物料資訊",
  请输入供货物料: "請輸入供應物料",
  拜访信息: "拜訪資訊",
  审计信息: "審計資訊",
  "拜访频次（次/年）": "拜訪頻次（次/年）",
  请输入拜访频次: "請輸入拜訪頻次",
  开始日期: "開始日期",
  结束日期: "結束日期",
  至: "至",
  请选择完整的拜访日期范围: "請選擇完整的拜訪日期範圍",
  拜访原因: "拜訪原因",
  请输入拜访原因: "請輸入拜訪原因",
  拜访内容: "拜訪內容",
  请输入拜访内容: "請輸入拜訪內容",
  拜访准备资料: "拜訪準備資料",
  拜访结果: "拜訪結果",
  审计结果: "審計結果",
  拜访会议纪要: "拜訪會議紀要",
  请输入拜访会议纪要: "請輸入拜訪會議紀要",
  会议相关資料: "會議相關資料",
  请选择审计需求工厂: "請選擇審計需求工廠",
  审计原因: "審計原因",
  请输入审计原因: "請輸入審計原因",
  审计内容: "審計內容",
  请输入审计内容: "請輸入審計內容",
  审计等级: "審計等級",
  请选择审计等级: "請選擇審計等級",
  审计结果评价: "審計結果評價",
  请输入审计结果评价: "請輸入審計結果評價",
  附件: "附件",
  上传文件: "上傳文件",
  文件上传: "文件上傳",
  点击上传: "點擊上傳",
  请先选择要导入的文件: "請先選擇要導入的文件",
  "只能上传 Excel 文件": "只能上傳 Excel 文件",
  "文件大小不能超过 10MB": "檔案大小不能超過 10MB",
  导入成功: "導入成功",
  "导入失敗,请重試": "導入失敗,請重試",
  模板下载成功: "模板下載成功",
  "模板下载失败，请重试": "模板下載失敗，請重試",
  "1. 下载导入模板": "1. 下載導入模板",
  下载模板: "下載模板",
  "请先下载模板,按照模板格式填写数据后再导入":
    "請先下載模板,按照模板格式填寫數據後再導入",
  "2. 上传文件": "2. 上傳文件",
  选择文件: "選擇文件",
  "支持 .xls 和 .xlsx 格式,文件大小不超过 10MB":
    "支持 .xls 和 .xlsx 格式,檔案大小不超過 10MB",
  确定导入: "確定導入",
  确认通知: "確認通知",
  "您确定要通知供应商吗？": "您確定要通知供應商嗎？",
  确定: "確定",
  取消: "取消",
  通知供应商成功: "通知供應商成功",
  "通知供应商失敗，请重试": "通知供應商失敗，請重試",
  记录ID不存在: "記錄ID不存在",
  填写拜访结果成功: "填寫拜訪結果成功",
  填写拜访結果失敗: "填寫拜訪結果失敗",
  请先选择供应商: "請先選擇供應商",
  请选择拜访日期: "請選擇拜訪日期",
  修改并通知成功: "修改並通知成功",
  提交并通知成功: "提交並通知成功",
  提交成功: "提交成功",
  操作失敗: "操作失敗",
  加载拜访记录详情失敗: "加載拜訪記錄詳情失敗",
  获取供应商列表失敗: "獲取供應商列表失敗",
  获取供应商详细信息失敗: "獲取供應商詳細資訊失敗",
  修改审计记录成功: "修改審計記錄成功",
  新增审计记录成功: "新增審計記錄成功",
  填写审计结果成功: "填寫審計結果成功",
  填写审计結果失敗: "填寫審計結果失敗",
  加载审计记录详情失敗: "加載審計記錄詳情失敗",
  获取供应商資訊失敗: "獲取供應商資訊失敗",
  "共 {{count}} 条数据": "共 {{count}} 條數據",
  请输入供应商编号搜索: "請輸入供應商編號搜尋",
  优秀: "優秀",
  良好: "良好",
  合格: "合格",
  不合格: "不合格",
  文件: "文件",
};
